import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaPlus, FaList, FaSignOutAlt, FaBook } from "react-icons/fa";
import { hasPermission } from "../utils/authUtils"; // Import the utility

export default function Sidebar() {
  const location = useLocation();
  const LOGOUT = process.env.REACT_APP_FE_MODULE_URL;

  // Check permissions
  const canCreateBook = hasPermission('book:create');
  const canViewBooks = hasPermission('book:read') || hasPermission('book:read:all');

  function buttonStyle(path) {
    const isActive = location.pathname === path;
    return {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      margin: "8px 0",
      background: isActive ? "#1e90ff" : "transparent",
      color: isActive ? "#fff" : "#ddd",
      border: "none",
      padding: "10px 14px",
      borderRadius: "8px",
      textAlign: "left",
      cursor: "pointer",
      width: "100%",
      transition: "all 0.3s ease",
      fontSize: "15px",
    };
  }

  return (
    <div
      style={{
        width: "220px",
        height: "97vh",
        backgroundColor: "#111",
        padding: "20px",
        boxShadow: "2px 0 8px rgba(0,0,0,0.4)",
        position: "fixed",
        top: 0,
        left: 0,
        flexDirection: "column",
        display: "flex",
        color: "white",
      }}
    >
      {/* Sidebar Header */}
      <div style={{ marginBottom: "30px", textAlign: "center" }}>
        <FaBook size={40} color="#1e90ff" />
        <h2 style={{ margin: "10px 0 0 0", fontSize: "20px", color: "#fff" }}>
          Book Manager
        </h2>
        <p style={{ fontSize: "12px", color: "#aaa" }}>Manage your library</p>
      </div>

      {/* Navigation - Only show if user has permission */}
      {canCreateBook && (
        <Link to="/create-book" style={{ textDecoration: "none" }}>
          <button style={buttonStyle("/create-book")}>
            <FaPlus /> Add Book
          </button>
        </Link>
      )}

      {canViewBooks && (
        <Link to="/book-list" style={{ textDecoration: "none" }}>
          <button style={buttonStyle("/book-list")}>
            <FaList /> Book List
          </button>
        </Link>
      )}

      {/* Logout */}
      <button
        style={{
          marginTop: "auto",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          backgroundColor: "red",
          color: "white",
          border: "none",
          padding: "10px 14px",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "15px",
        }}
        onClick={() => {
          localStorage.clear(); 
          // window.location.href = window.location.origin + window.location.pathname;
          window.location.href = "/";
        }}
      >
        <FaSignOutAlt /> Logout
      </button>
    </div>
  );
}